import { AnimatePresence } from 'framer-motion'
import React from 'react'
import { Oval } from 'react-loader-spinner'

function SmallButton({ loading = false, children, ...rest }) {
    return (
        <button {...rest}
            className={`size-11 rounded-full shadow-lg bg-white text-black
          flex justify-center items-center hover:bg-black hover:text-white`}>
            {loading ?
                <AnimatePresence>
                    <Oval
                        width={16}
                        strokeWidth={5}
                        height={16}
                        color='black'
                        secondaryColor='black'
                    />
                </AnimatePresence> :
                children
            }
        </button>
    )
}

export default SmallButton